export default __webpack_public_path__ + "static/media/healtea2.fd5aebb8.jpg";